import React from 'react';
import { IValueDateRow } from './interface';
import { ValueRow } from '../ValueRow';
import { formatLocaleDate } from '../../../helpers/dateHelpers';

export const ValueDateRow: React.FC<IValueDateRow> = ({
  label,
  date,
  withTime = true,
  width = '50px',
}): JSX.Element => {
  return (
    <ValueRow label={label} width={width}>
      {formatLocaleDate(date, withTime)}
    </ValueRow>
  );
};
